<script lang="ts">
  import Card from '@smui/card';
  import Checkbox from '@smui/checkbox';
  import { _ } from 'svelte-i18n';
  import FormLoading from '../../../../../../shared/components/common/Loading/FormLoading.svelte';
  import Title from '../../../../../../shared/components/common/Title.svelte';
  import PSCLElaborazione from '../../../../../../shared/models/PSCL/Elaborazione/PSCLElaborazione';

  export let params = {
    id: '0',
  };

  let [data, loading, error] = PSCLElaborazione.get(params.id);
  let [dataSubmit, loadingSubmit, errorSubmit] = [null, null, null];

  function onSubmit() {
    const updatedData = {
      id: $data.id,
      psclCategorie: $data.psclCategorie.map(categoria => ({
        id: categoria.id,
        psclMisure: categoria.psclMisure.map(misura => ({
          id: misura.id,
          applicata: misura.applicata
        }))
      }))
    };

    [dataSubmit, loadingSubmit, errorSubmit] = PSCLElaborazione.saveAppliedMeasures(updatedData);
  }

  const lastYear = new Date().getFullYear() - 1;
</script>

<Card class="md:px-8 md:py-8" padded>
  <div class="flex justify-between">
    <Title title="Monitoraggio misure {lastYear}" />
    <div class="flex flex-wrap sm:flex-nowrap sm:space-x-4">
      <button type="button" on:click={onSubmit} class="btn-white h-14 w-14 sm:h-16 sm:w-16" disabled={$loadingSubmit}>
        <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
      </button>
    </div>
  </div>
  
  {#if $loading}
    <FormLoading />
  {:else if $error}
    <p class="text-red-500">Si è verificato un errore nel caricamento dei dati.</p>
  {:else}
      <div class="font-bold text-center text-red-600">
      ATTENZIONE: spuntare le misure inserite nel PSCL dello scorso anno e che poi sono state implementate nel corso dell'anno corrente. Ricorda di salvare!
    </div>
    <div class="mb-4">
      <p><strong>{$_('page.pscl.detail.processing_name')}:</strong> {$data.descrizione}</p>
      <p><strong>{$_('page.pscl.detail.location')}:</strong> {$data.sede?.denominazione}</p>
      <p><strong>{$_('page.pscl.detail.survey')}:</strong> {$data.questionario?.descrizione}</p>
    </div>

    {#each $data.psclCategorie as categoria}
      <div class="mb-6">
        <h2 class="mb-2 text-xl font-semibold">{categoria.descrizione}</h2>
        {#each categoria.psclMisure as misura}
          <div class="flex items-center p-2 mb-2 bg-gray-100 rounded">
            <Checkbox 
              bind:checked={misura.applicata} 
            />
            <span class="ml-4">
              {misura.nome} - 
              Costo implementazione: {misura.costoImplementazione}€ | 
              Costo gestione: {misura.costoGestione}€
            </span>
          </div>
        {/each}
      </div>
    {/each}

    {#if $errorSubmit}
      <p class="mt-2 text-red-500">Si è verificato un errore durante il salvataggio.</p>
    {/if}
  {/if}
</Card>